import type { ReactNode } from "react";
import { Link } from "../lib/router";
import { LogoMark } from "./LogoMark";

const twitterUrl = import.meta.env.VITE_TWITTER_URL?.trim();
const telegramUrl = import.meta.env.VITE_TELEGRAM_URL?.trim();

function SocialLink({ href, label, children }: { href?: string; label: string; children: ReactNode }) {
  if (!href) {
    return <span className="footer-social is-disabled" role="img" aria-label={`${label} channel coming soon`}>{children}</span>;
  }

  return <a className="footer-social" href={href} target="_blank" rel="noreferrer" aria-label={label}>{children}</a>;
}

export function Footer({ onLaunch }: { onLaunch(): void }) {
  return (
    <footer className="site-footer">
      <Link className="footer-logo" href="/" aria-label="Bubble Hood home"><LogoMark /></Link>
      <nav className="footer-nav" aria-label="Footer navigation">
        <button type="button" onClick={onLaunch}>Launch</button>
        <Link className="footer-optional" href="/portfolio">Portfolio</Link>
        <Link href="/docs">Docs</Link>
        <Link className="footer-optional" href="/risks">Risks</Link>
        <a className="footer-optional" href="https://www.tradingview.com/" target="_blank" rel="noreferrer" title="TradingView Lightweight Charts™ Copyright © 2025 TradingView, Inc.">Charts © TradingView</a>
      </nav>
      <div className="footer-socials" aria-label="Social channels">
        <SocialLink href={twitterUrl} label="Bubble Hood on X">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4 19 20M19 4 5 20" /></svg>
        </SocialLink>
        <SocialLink href={telegramUrl} label="Bubble Hood on Telegram">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m3 11 18-8-5 18-5-7-4 3 1-5 9-6-10 5H3Z" /></svg>
        </SocialLink>
      </div>
    </footer>
  );
}
